<div class="funding-container">
  @if (featureSettingsService.financementEnabled) {
  <div class="body-header">
    <div id="title-slider">
      <span class="casto-title" [innerHTML]="'funding.title' | translate"></span>
      <div class="slider-input-container">
        <span [innerHTML]="'funding.down-amount' | translate"></span>
        <div class="slider-container">
          @if (pricingLoading) {
            <p-skeleton class="slider-skeleton" height="46px"></p-skeleton>
          } @else {
            <div class="slider">
              <p-slider
                [(ngModel)]="this.downPayment"
                [min]="0"
                [max]="currentPricing?.totalWithoutFunding.actualAmount"
                [step]="0.01"
                (onSlideEnd)="updateFunding()" />
              <div class="min-max">
                <span [innerHTML]="0 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
                <span
                  [innerHTML]="
                  currentPricing?.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                "></span>
              </div>
            </div>


            <p-inputNumber
              #pInput
              [(ngModel)]="downPayment"
              mode="currency"
              inputId="currency-france"
              currency="EUR"
              locale="fr-FR"
              (keydown.enter)="updateFunding()" />

          }
        </div>
      </div>
    </div>
    <div id="amounts">
      <div class="amount">
        <span class="casto-title" [innerHTML]="'funding.total-amount' | translate"></span>
        @if (pricingLoading) {
          <p-skeleton width="6rem" height="1rem"></p-skeleton>
        } @else {
          <div class="amount-values">
            @if (displayDiscount) {
              <span
                class="casto-discount"
                [innerHTML]="
                            currentPricing.totalWithoutFunding.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          "></span>
            }
            <span
              class="blue"
              [innerHTML]="
            currentPricing?.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          "></span>
          </div>
        }
      </div>
      <div class="amount">
        <span class="casto-title" [innerHTML]="'funding.funding-amount' | translate"></span>
        @if (pricingLoading) {
          <p-skeleton width="6rem" height="1rem"></p-skeleton>
        } @else {
          <span class="casto-tag" [innerHTML]="fundingAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }</div>
    </div>
  </div>
  <div class="panel">
    <div class="panel-content">
      @if (loading || pricingLoading) {
        <div class="loader-container">
          <ng-casto-loader></ng-casto-loader>
        </div>
      }
      <div class="casto-card">
        <div class="content">
          @if (isNoOffer()) {
            <span class="no-offer" [innerHTML]="'funding.no-offers' | translate"></span>
          } @else {
            <p-table styleClass="casto-table" [value]="offersWithFooter" [scrollable]="true" scrollHeight="100%">
              <ng-template pTemplate="header">
                <tr>
                  @for (col of offersColumns; track col) {
                    <th>
                      {{ col.header }}
                    </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-offer>
                @if (offer.isTextContainer) {
                  <!-- Ligne spéciale pour le texte de financement -->
                  <tr class="funding-row">
                    <td [attr.colspan]="offersColumns.length" class="funding-cell">
                      <div class="funding-text-container">
                        <span [innerHTML]="funding?.txtAssurance"></span>
                        <span [innerHTML]="funding?.vac"></span>
                      </div>
                    </td>
                  </tr>
                } @else {
                  <!-- Lignes normales du tableau -->
                  <tr
                    [ngClass]="{
                        highlighted: isOfferSelected(offer),
                      }"
                    (click)="selectOffer(offer)">
                    <td>{{ offer.code }}</td>
                    <td>{{ offer.offer }}</td>
                    <td>
                        <span
                          class="blue"
                          [innerHTML]="offer.mensuality | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
                    </td>
                    <td>{{ offer.duration }}</td>
                    <td [innerHTML]="offer.interest | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></td>
                    <td [innerHTML]="offer.total | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></td>
                    <td>
                      <span class="casto-tag">{{ offer.taeg }}%</span>
                    </td>
                  </tr>
                }
              </ng-template>
              <ng-template pTemplate="emptymessage">
                @if (!(loading || pricingLoading)) {

                  <div class="offer-error-container">
                  <span
                    class="no-offer" [innerHTML]="'funding.error'|translate"></span>
                    <ng-casto-button [label]="'Relancer la recherche'" (click)="updateFunding()"></ng-casto-button>
                  </div>
                } @else {
                  <tr>
                    <td></td>
                    <td></td>
                    <td>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>

                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>
          }
        </div>
      </div>
    </div>
  </div>
  @if (!currentWithInstallation) {
    <div class="panel-content" (click)="setWithInstallation(true)" id="installation">
      <div class="casto-card">
        <div class="header">
            <span
              class="casto-title"
              [innerHTML]="
                'installation.storage.with-installation.title'
                  | translate
                    : {
                        amount: currentPricing?.delta.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                      }
              "></span>
          <ng-casto-button
            class="primary"
            [label]="'generic.details' | translate"
            (click)="setWithInstallation(true)"></ng-casto-button>
        </div>
      </div>
    </div>
  } @else {
    <div class="panel-content" (click)="setWithInstallation(false)" id="installation">
      <div class="casto-card">
        <div class="header">
            <span
              class="casto-title"
              [innerHTML]="
                'installation.storage.without-installation.title'
                  | translate
                    : {
                        amount: currentPricing?.delta.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                      }
              "></span>
          <ng-casto-button
            class="primary"
            [label]="'generic.details' | translate"
            (click)="setWithInstallation(false)"></ng-casto-button>
        </div>
      </div>
    </div>
  }
  } @else {
    <div class="panel feature-disabled-panel">
      <div class="panel-content">
        <div class="alert alert-warning m-0 text-center" [innerHTML]="'feature-settings.warning.financement' | translate"></div>
      </div>
    </div>
  }
</div>
